import { useGetEmisoresQuery } from "@/features/configuracion/emisor/api/get-emisor";

export function useEmisorData() {
    const { data: emisores, isLoading, error } = useGetEmisoresQuery();
    
    //obtener el primer emisor por default TODO: tener codificado el id default de emisor?
    const emisor = emisores?.[0];
    
    return {
        emisor,
        isLoading,
        error,
        hasEmisor: !!emisor
    };
}
